<template>
  <transition name="fade">
    <div name="modal" v-if="isVisible">
      <div :class="`modal-mask ${isAlert ? 'alert-animation' : ''}`">
        <div class="modal-wrapper">
          <div class="modal-body">
            <div class="modal-container-window">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ReusableWindow',
  props: {
    isAlert: false,
  },
  data: () => ({
    isVisible: false,
    resolvePromise: null,
  }),
  methods: {
    open() {
      this.isVisible = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    close(promiseResolution = true) {
      this.isVisible = false;
      if (this.resolvePromise) {
        this.resolvePromise(promiseResolution);
        // this.rejectPromise(new Error('Se canceló la acción.'))
        this.resolvePromise = null;
      }
    },
  },
};
</script>
